// ANCHOR React
import { ReactNode } from 'react';

// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Models
import {
  useCourseDataDraft,
} from '@lyon/scoped-models/CourseData';
import { ProviderCheckManager } from '@lyon/scoped-models/ProviderCheckManager';
import { useCourseInstructorCheckData } from '@lyon/scoped-models/CourseInstructorCheck';

// ANCHOR Graph State
import { useAuthState } from '@lyon/nodes/firebase/auth/auth-state-node';

// ANCHOR Components
import { Lyon404 } from '@lyon/components/404/Lyon404';
import { LyonPage } from '@lyon/components/LyonPage';
import { Loader } from '@lyon/components/utils/Loader';

// ANCHOR Styles
import { CONTAINER } from './styles';

interface IProps {
  children: ReactNode;
}

function LyonCourseRootContainer({ children }: IProps) {
  return (
    <LyonPage hideSidebar>
      <Block overrides={CONTAINER}>
        {children}
      </Block>
    </LyonPage>
  );
}

export function LyonCourseContainer({ children }: IProps) {
  const isDraft = useCourseDataDraft();
  const user = useAuthState();
  const isProvider = ProviderCheckManager.useSelector((state) => state.data);
  const isCourseInstructor = useCourseInstructorCheckData();

  if ((user === null || user) && !isDraft) {
    return (
      <LyonCourseRootContainer>
        {children}
      </LyonCourseRootContainer>
    );
  }

  if (typeof user === 'undefined') {
    return (
      <LyonCourseRootContainer>
        <Loader />
      </LyonCourseRootContainer>
    );
  }

  if (isDraft && (!isProvider && !isCourseInstructor)) {
    return <Lyon404 />;
  }

  return (
    <LyonCourseRootContainer>
      {children}
    </LyonCourseRootContainer>
  );
}
